import React, { useEffect, useState } from "react";
import { Zap, Loader2 } from "lucide-react";
import { api } from "../lib/api";

export const CreditPacks = ({ onBuy, busyId, cta = "Buy credits" }) => {
  const [packs, setPacks] = useState(null);
  useEffect(() => { api.creditPacks().then(setPacks).catch(() => setPacks([])); }, []);

  if (!packs) return <div className="grid grid-cols-1 md:grid-cols-3 gap-5">{[0, 1, 2].map((i) => <div key={i} className="h-64 rounded-2xl shimmer" />)}</div>;
  if (!packs.length) return <p className="text-sm text-slate-500" data-testid="credit-packs-empty">Credit packs are not available right now.</p>;

  return (
    <div className={`grid grid-cols-1 md:grid-cols-2 ${packs.length >= 3 ? "lg:grid-cols-3" : ""} gap-5`} data-testid="credit-packs">
      {packs.map((p) => (
        <div key={p.id} data-testid={`credit-pack-${p.id}`}
          className={`relative flex flex-col justify-between rounded-3xl border p-7 bg-white transition-colors ${p.popular ? "border-sky-300 shadow-[0_12px_40px_-12px_rgba(14,165,233,0.35)]" : "border-slate-200 hover:border-slate-300"}`}>
          {p.popular && <span className="absolute -top-3 left-7 px-2.5 py-0.5 rounded-full bg-slate-900 text-white text-[11px] font-semibold">Most popular</span>}
          <div>
            <div className="text-sm text-slate-500">{p.name}</div>
            <div className="mt-3 flex items-baseline gap-1.5">
              <span className="font-display text-4xl font-bold text-slate-900" data-testid={`credit-pack-price-${p.id}`}>₹{p.price_inr.toLocaleString("en-IN")}</span>
              <span className="text-sm text-slate-500">one-time</span>
            </div>
            <div className="mt-4 flex items-center gap-2 text-slate-800 font-mono text-sm"><Zap size={14} className="fill-amber-400 text-amber-500" /> {p.credits.toLocaleString("en-IN")} credits</div>
            <p className="mt-1 text-xs text-slate-400">₹{(p.price_inr / p.credits).toFixed(2)} per credit</p>
            {p.tagline && <p className="mt-2 text-sm text-slate-500">{p.tagline}. Paid credits never expire.</p>}
          </div>
          <button onClick={() => onBuy(p.id)} disabled={busyId === p.id} data-testid={`buy-credits-pack-${p.id}`}
            className={`mt-7 h-11 rounded-full text-sm font-semibold flex items-center justify-center gap-2 transition-colors disabled:opacity-60 ${p.popular ? "bg-slate-900 text-white hover:bg-slate-700" : "bg-slate-100 text-slate-900 hover:bg-slate-200"}`}>
            {busyId === p.id && <Loader2 size={15} className="animate-spin" />} {cta}
          </button>
        </div>
      ))}
    </div>
  );
};

export default CreditPacks;
